import { useDispatch } from 'react-redux';
import { store } from './store'; 
import type { UnknownAction, ThunkDispatch } from '@reduxjs/toolkit';

// This file is a temporary fix for conflicts between dispatch and redux-thunk
// should be incorporated into store.js following typescript conversion
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;

export const useAppDispatch = () => useDispatch<AppDispatch>();